import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadDynamicComponentService {
  rightSidebarSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isRightOpen$ = this.rightSidebarSubject.asObservable();

  toggleRightSidebar(state: boolean) {
    this.rightSidebarSubject.next(state);
  }
}
